import { OrderType, PropertyType } from '@inspectify/core';
import { TabContext, TabPanel } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import { Link, Tab, Toolbar, useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOrderPropertyPhotoQuery } from '../../../gql/generated/queries';
import { Property } from '../../Property';
import RehabDrawerTabPanel from './RehabDrawerTabPanel';
import ReportDrawerTabPanel from './ReportDrawerTabPanel';
import LoadingSkeleton from "./LoadingSkeleton";
import { reportActions } from "../../../redux/slices/reportSlice/report";
import { useAppDispatch } from "../../../redux/store";
import { useWhiteLabelling } from 'hooks/useWhiteLabelling';

const ReportDrawerContent = () => {
  const { orderToken } = useParams();
  const { data, isLoading } = useGetOrderPropertyPhotoQuery({ token: orderToken || '' });
  const dispatch = useAppDispatch();
  const whiteLabelling = useWhiteLabelling();
  const theme = useTheme();

  // TODO: Implement rehab
  const showRehab = false; //!!rehabData?.rehabProjects?.edges?.length;

  const [value, setValue] = React.useState('0');

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (data) {
      dispatch(reportActions.setOrder(data.orderByToken as OrderType));
    }
  }, [data]);

  if (isLoading) return <LoadingSkeleton />;

  return (
    <Stack alignItems="center" sx={{ width: '100%' }}>
      <Toolbar>
        <Link href="/" sx={{display: 'flex'}}>
          <img src={theme.palette.mode === 'dark' ? whiteLabelling.logoLightUrl : whiteLabelling.logoUrl} width={150} alt={whiteLabelling.displayName} />
        </Link>
      </Toolbar>
      <Property
        property={data?.orderByToken?.property as PropertyType}
        showAddress
        imageStyle={{ width: '100%' }}
        placeholderStyle={{ height: 200 }}
      />
      {showRehab ? (
        <TabContext value={value}>
          <TabList
            onChange={handleChange}
            aria-label="Report Tabs"
            variant="fullWidth"
            sx={{ width: '100%' }}
          >
            <Tab label="Report" value="0" />
            <Tab label="Rehab" value="1" />
          </TabList>
          <TabPanel value="0" sx={{ width: '100%', padding: 0 }}>
            <ReportDrawerTabPanel />
          </TabPanel>
          <TabPanel value="1" sx={{ width: '100%' }}>
            <RehabDrawerTabPanel />
          </TabPanel>
        </TabContext>
      ) : <ReportDrawerTabPanel />}
    </Stack>
  );
};

export default ReportDrawerContent;

